import { render, staticRenderFns } from "./HistoryLimits.vue?vue&type=template&id=1402d643&"
import script from "./HistoryLimits.vue?vue&type=script&lang=js&"
export * from "./HistoryLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports